import { IonContent, IonPage } from '@ionic/react';
import React from 'react';

export default function ErrorPage() {
  return (
    <IonPage>
      <IonContent>
        <div className="h-full w-full flex flex-col gap-2 items-center high-emphasis-text font-bold justify-center">
          <h1>Oops! 404</h1>
          <h6 className="medium-emphasis-text font-medium">Page Not found</h6>
        </div>
      </IonContent>
    </IonPage>
  );
}
